// extracted by mini-css-extract-plugin
module.exports = {"date":"InputDate_date_1nNOI"};